/*
*   Actions which are passed from accreditation.reducer.js to tasks.reducer.js
 */

export const PREFIX = 'ACC_TASKS';

export const TYPES = {
    FETCH_SCHEMES:              `${PREFIX}_FETCH_SCHEMES`,
    LOCALIZE_TASKS_GRID_FILTER: `${PREFIX}_LOCALIZE_TASKS_GRID_FILTER`,
    TASK_DETAILS_REFRESH:       `${PREFIX}_TASK_DETAILS_REFRESH`,
    IMPROVEMENT_ACTION_REFRESH: `${PREFIX}_IMPROVEMENT_ACTION_REFRESH`,
    SAVE_UPLOADED_DOCUMENT:     `${PREFIX}_SAVE_UPLOADED_DOCUMENT`,
};
